<template>
  <v-container>
    <CashDailyTable />
  </v-container>
</template>
<script>
// import { mapGetters, mapActions, mapMutations } from 'vuex'
// import { db, fb } from '@/api/firebase.js'
import CashDailyTable from '@/components/CashDailyTable.vue'

export default {
  name: 'CashDaily',
  components: { CashDailyTable },
  data: () => ({
  }),

  computed: {
  // ...mapGetters()
  },

  watch: {
  },

  created () {
  },

  methods: {
  // ...mapMutations(),
  // ...mapActions()
  }
}
</script>
<style type="text/css">
</style>
